var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.div.class,attrs:{"id":"cartSubscribe"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.div.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }